module.exports = __webpack_public_path__ + "img/water-green-inner-corner.451ea9e7.png";